import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
import leaderboardIllustration from '../../../assets/images/bttf/leaderboard-illus.png';
import levelsIllustration from '../../../assets/images/bttf/levels-illus.png';
import tffpIcon from '../../../assets/images/bttf/tffp.png';
import geoveloIcon from '../../../assets/images/geovelo.svg';
import missionIllustration from '../../../assets/images/mission-illus.svg';
const sponsors = [{
  key: 'geovelo',
  icon: geoveloIcon,
  title: 'Geovelo',
  description: 'Expert des itinéraires vélo sécurisés et de la mobilité durable'
}, {
  key: 'tffp',
  icon: tffpIcon,
  title: 'Team for the Planet',
  description: 'Collectif citoyen engagé contre le dérèglement climatique'
}];
function InfoCard({
  event
}) {
  if (event.code?.toLowerCase() !== 'bttf') return /*#__PURE__*/React.createElement(React.Fragment, null);
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    border: "1px solid #D9E7FF",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 5,
    padding: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontSize: "1.25rem",
    fontWeight: 700
  }, "Un challenge \xE0 points engag\xE9 organis\xE9 par Team for the Planet et Geovelo"), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, "Transformons symboliquement nos rues, nos quartiers et notre quotidien, simplement en p\xE9dalant collectivement\xA0!")), /*#__PURE__*/React.createElement(Card, {
    description: /*#__PURE__*/React.createElement(React.Fragment, null, "Les \xE9missions de CO2 \xE9vit\xE9es gr\xE2ce aux trajets v\xE9lo de tous les participants permettent de transformer petit \xE0 petit notre ville en une ville moins carbon\xE9e et plus souhaitable\xA0!"),
    illustration: levelsIllustration,
    title: "Roulez pour b\xE2tir ensemble une cit\xE9 id\xE9ale"
  }), /*#__PURE__*/React.createElement(Card, {
    description: /*#__PURE__*/React.createElement(React.Fragment, null, "Gagnez des points en faisant des kilom\xE8tres \xE0 v\xE9lo avec l'application Geovelo. Bonus pour votre premier trajet v\xE9lo, vos trajets domicile-travail, et si vous invitez des coll\xE8gues\xA0!"),
    illustration: leaderboardIllustration,
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Cumulez des points d'impact et surpassez les autres entreprises\xA0!")
  })), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontSize: "1.25rem",
    fontWeight: 700
  }, "Une alliance engag\xE9e"), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, "Plus qu'un simple challenge v\xE9lo, Bike to the Future est organis\xE9 par deux acteurs engag\xE9s\xA0:")), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "stretch",
    display: "flex",
    flexWrap: "wrap",
    gap: 3
  }, sponsors.map(({
    key,
    icon,
    title,
    description
  }) => /*#__PURE__*/React.createElement(_Box, {
    key: key,
    width: {
      '@': '100%',
      '@500': 'calc((100% - 24px) / 2)',
      '@800': '100%',
      '@900': 'calc((100% - 24px) / 2)'
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    border: "1px solid #dde0e7",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    height: "100%",
    padding: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#f3f6ff",
    borderRadius: 8,
    display: "flex",
    height: 64,
    justifyContent: "center",
    width: 64
  }, /*#__PURE__*/React.createElement("img", {
    src: icon,
    width: 32
  })), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    fontWeight: 700
  }, title), /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    variant: "body2"
  }, description))))))), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#ecfbf4",
    borderRadius: 3,
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@500': 'row'
    },
    gap: 3,
    padding: 3
  }, /*#__PURE__*/React.createElement("img", {
    src: missionIllustration,
    style: {
      flexShrink: 0
    },
    width: 100
  }), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, "Notre mission commune : r\xE9duire l'empreinte carbone des trajets quotidien en favorisant la mobilit\xE9 douce. Chaque kilom\xE8tre p\xE9dal\xE9, c'est un pas de plus vers une ville plus vivable, plus verte, plus humaine\xA0!")));
}
function Card({
  illustration,
  title,
  description
}) {
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@500': 'row',
      '@800': 'column',
      '@900': 'row'
    },
    gap: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    width: {
      '@': '100%',
      '@500': 224,
      '@800': '100%',
      '@900': 224
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: illustration,
    width: "100%"
  })), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    fontWeight: 700
  }, title), /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, description)));
}
export default InfoCard;